import type { FaireProductEntity } from "../../entity_types/product";

export const p_zssvf4edaz: FaireProductEntity = {
  token: "p_zssvf4edaz",
  type: "product",
  name: "I ❤️ Being Weird Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/fbcb64bcf97696bc897cf5711b904a482411d555f354638d0214e09d51fb6017.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/111dc3414512b04f06616c1aac2ec84bea742f22bc477f64c6856e1fa0fa5518.jpeg",
    "https://cdn.faire.com/fastly/68d1055dd9b189d8f97373f025176254c7147b3bcfbafbe3a3d5be1e72e8105c.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/715eb7c650616a57e6feb2e334990f91f9ba26eeaa6fc33f98929f0765997295.jpeg",
    "https://cdn.faire.com/fastly/5e3594136c708d3f7e4f219ee6d9e35cf61f2bea2000e79c7066641a4fae238b.jpeg"
  ],
  priceDollars: 6.75,
  description: "“Weird” is what boring people call things that scare and perplex them. Let these socks embrace your feet like you embrace your weirdness 🤗 🧦\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:24.455Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
